import React from "react";

/**
 * StatusPill — spec-compliant status badge per broadcastflow_typography_spec.md
 *
 *   <StatusPill status="published">Published</StatusPill>
 *   <StatusPill status="pending">Awaiting approval</StatusPill>
 *   <StatusPill status="failed">Render failed</StatusPill>
 *
 * Recognised statuses: draft | approved | published | pending | failed | rejected
 *
 * Renders a 10px / 500 / pill (2×8 padding · 20 px radius) using the spec's
 * BG/text colour tokens. Unknown statuses fall back to `draft` styling.
 */
const STATUS_CLASS = {
  draft:     "badge-pill badge-draft",
  approved:  "badge-pill badge-approved",
  published: "badge-pill badge-published",
  pending:   "badge-pill badge-pending",
  failed:    "badge-pill badge-failed",
  rejected:  "badge-pill badge-rejected",
};

export default function StatusPill({ status = "draft", children, className = "", ...rest }) {
  const cls = STATUS_CLASS[status] || STATUS_CLASS.draft;
  return (
    <span className={`${cls} ${className}`} data-status={status} {...rest}>
      {children}
    </span>
  );
}
